import { render, staticRenderFns } from "./Clients.vue?vue&type=template&id=5e779b5a&scoped=true"
import script from "./Clients.vue?vue&type=script&lang=ts"
export * from "./Clients.vue?vue&type=script&lang=ts"
import style0 from "./Clients.vue?vue&type=style&index=0&id=5e779b5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e779b5a",
  null
  
)

export default component.exports